module.exports = __webpack_public_path__ + "/assets/fonts/Vazir-Bold.woff";